export type MusicDurationControlPresentation = {
    label: string
    detail: string | null
}

export function musicDurationControlPresentation(
    actionTagName?: string | null,
): MusicDurationControlPresentation {
    if (actionTagName === 'minimaxmusic') {
        return {
            label: 'Target duration (approximate)',
            detail: 'MiniMax chooses the final track length',
        }
    }

    if (actionTagName === 'suno') {
        return {
            label: 'Target duration',
            detail: 'Exact with custom lyrics or instrumental; approximate otherwise',
        }
    }

    return { label: 'Duration', detail: null }
}
